import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Seo from "components/Seo";
import toast, { Toaster } from "react-hot-toast";
import Input from "../../-components/common/Input";
import MorningLayout from "../../morningLayout";
// import CheckBox from "../../-components/common/Checkbox";
import Button from "../../-components/common/Button";
import { usePostLogin } from "hooks/morning/usePostLogin";
import { ilshinGroupPhone } from "hooks/utils/util";
import { useAppContext } from "context/AppContext";
import { useMorningAuthStore } from "store/useMorningAuthStore";

const LoginPage = () => {
    const navigate = useNavigate();
    const { isApp } = useAppContext();
    // const [saveCode, setSaveCode] = useState<boolean>(false);
    const saveCode = localStorage.getItem("morning_code");
    const [code, setCode] = useState<string>(saveCode ?? "");
    const [number, setNumber] = useState("");
    const [codeError, setCodeError] = useState(false);
    const [numberError, setNumberError] = useState(false);
    const [accountError, setAccountError] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isCodeError = codeError || (isSubmitting && code.length === 0);
    const isNumberError = numberError || (isSubmitting && number.length === 0);

    const { mutate } = usePostLogin();

    const handleLogin = () => {
        setIsSubmitting(true);
        let hasError = false;

        if (!code.trim()) {
            setCodeError(true);
            hasError = true;
        }
        if (!number.trim()) {
            setNumberError(true);
            hasError = true;
        }

        const isValid = /^[0-9]+$/.test(code);
        if (!isValid) {
            setAccountError(true);
            hasError = true;
        }

        if (hasError) return;

        // if (saveCode) {
        //     localStorage.setItem("morning_code", code);
        // } else {
        //     localStorage.removeItem("morning_code");
        // }

        mutate(
            { c_code: code, c_company_number: number },
            {
                onSuccess: () => {
                    toast.remove();
                    localStorage.setItem("morning_code", code);
                    navigate("/");
                },
                onError: (error: any) => {
                    let message = "";
                    if (error.status === 403) {
                        message = "변경된 코드를 확인하세요";
                    } else if (error.status === 404) {
                        message = `거래처 코드 또는 사업자번호를 잘못입력했습니다.\n 입력하신 내용을 다시 확인해 주세요.`;
                    } else {
                        message = error.response.data.message;
                    }

                    toast.error(message, {
                        style: {
                            width: "100%",
                            maxWidth: "560px",
                            backgroundColor: "#FF4242",
                            padding: "16px",
                            fontSize: "18px",
                            color: "#ffffff",
                        },
                    });
                },
            },
        );
    };

    // useEffect(() => {
    //     const savedCode = localStorage.getItem("morning_code");
    //     if (savedCode) {
    //         setCode(savedCode);
    //         setSaveCode(true);
    //     }
    // }, []);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Enter") {
                handleLogin();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
        // }, [code, number, saveCode]);
    }, [code, number]);

    const { host } = window.location;
    const parts = host.split(".");
    const isDomainDevelop = parts.includes("likeweb"); // 개발운영모드
    
    const handleLogout = () => {
        const { logout } = useMorningAuthStore.getState();
        logout();

        const afterLogoutToken = useMorningAuthStore.getState().accessToken;
        alert("현재 저장된 토큰: " + (afterLogoutToken ?? "없음"));
    };

    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="로그인" />
            <div className={`flex-1 flex flex-col relative ${!isApp && "mt-[116px]"}`}>
                <MorningLayout>
                    <div className="flex-1 flex h-full flex-col items-center pb-40 bg-[#F8F8F8] px-[4%]">
                        {
                            isDomainDevelop && <button onClick={handleLogout} className="my-10">로그아웃</button>
                        }
                        <p className="text-[#1B1C1E] text-[36px] font-bold mt-16 mb-8">로그인</p>
                        <div className="flex flex-col bg-white border border-new w-full max-w-[560px] items-center rounded-lg px-5">
                            <p className="text-new font-bold text-[18px] py-[10px]">회원 로그인</p>
                            <div className="flex flex-col w-full max-w-[400px] mx-auto py-[45px]">
                                <div className="mb-6">
                                    <p className="text-[#1b1c1e] text-[18px] font-[600] pb-1">거래처코드</p>
                                    <Input
                                        autoFocus
                                        error={codeError}
                                        value={code}
                                        onChange={e => {
                                            setCode(e.target.value);
                                            setCodeError(false);
                                            setAccountError(false);
                                        }}
                                        className="w-full max-w-[394px]"
                                        placeholder="거래처코드를 입력하세요"
                                    />
                                    {isCodeError && <p className="text-[15px] text-[#ff4242] mt-2">거래처코드를 입력하세요.</p>}
                                </div>
                                <div className="mb-2">
                                    <p className="text-[#1b1c1e] text-[18px] font-[600] pb-1">사업자번호 (앞 5자리)</p>
                                    <Input
                                        error={numberError}
                                        value={number}
                                        onChange={e => {
                                            setNumber(e.target.value);
                                            setNumberError(false);
                                        }}
                                        className="w-full max-w-[394px]"
                                        placeholder="사업자번호를 입력하세요"
                                        type="password"
                                    />
                                    {isNumberError && <p className="text-[15px] text-[#ff4242] mt-2">사업자번호를 입력하세요.</p>}
                                </div>
                                {/* <CheckBox
                                className="-ml-1"
                                label="거래처코드 저장"
                                checked={saveCode}
                                onChange={() => setSaveCode(!saveCode)}
                            /> */}
                                <div className="flex gap-2 my-8 responsive450:flex-col-reverse">
                                    {/*<Button*/}
                                    {/*    size="L"*/}
                                    {/*    onClick={() => {*/}
                                    {/*        navigate("/customer/online-order", {*/}
                                    {/*            state: { guest: true },*/}
                                    {/*        });*/}
                                    {/*    }}*/}
                                    {/*    className="responsive450:w-full"*/}
                                    {/*>*/}
                                    {/*    비회원 오더접수*/}
                                    {/*</Button>*/}
                                    <Button
                                        onClick={handleLogin}
                                        size="L"
                                        className="border-none bg-new text-white w-full responsive450:w-full "
                                    >
                                        로그인
                                    </Button>
                                </div>

                                {accountError && (
                                    <div className="pt-2 pb-10 text-center text-[#ff4242]">
                                        안녕하세요, 회원님. <br />
                                        현재 계정으로는 새 홈페이지 이용이 불가능합니다. <br />
                                        이전 홈페이지에서 업무를 진행해 주세요. <br />
                                        <button
                                            type="button"
                                            onClick={() => {
                                                const src = "http://oldmorning.ilshingroup.com";
                                                window.open(src, "_blank", "noopener, noreferrer");
                                            }}
                                            className="bg-new text-white px-10 py-2 rounded-[8px] mt-3"
                                        >
                                            구 모닝택배 홈페이지로 이동
                                        </button>
                                    </div>
                                )}

                                <p className="text-[#878a93] text-[18px] text-center responsive450:text-[16px]">
                                    아직 일신택배 회원이 아니거나 <br /> 거래처코드가 기억나지 않으신가요?
                                </p>
                                <p className="pt-2 justify-center flex items-center text-[18px] text-[#1b1c1e] font-bold">
                                    고객센터
                                    <span className="ml-2 text-[36px] text-new responsive450:text-[24px]">
                                        {ilshinGroupPhone("morning")}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </MorningLayout>

                <Toaster position="bottom-center" reverseOrder={false} />
            </div>
        </React.Fragment>
    );
};

export default LoginPage;
